<template>
    <div class="ModalNps">
        
        <b-modal :ref="'modal-nps'" :id="'modal-nps'" :size="'lg'" :hide-footer="true" :hide-header="true" :no-close-on-backdrop="true">
            <div class="modal-body">
                <div class="d-flex txt-h-2 txt-blue-2 modal-titulo">
                    <span class=" txt-w-20">Avaliação de Satisfação</span>
                </div>
                <div class="modal-conteudo">
                    <div class="mt-2">
                        <p class="txt-p txt-grey-2">
                            <strong>Sua opinião é muito importante!</strong> Responda a pesquisa para prosseguir
                        </p>
                        <p class="txt-p txt-grey-2 mt-4">
                            <strong>Em uma escala de 0 a 10, o qual nota você daria para a plataforma Sollicita ?</strong>
                        </p>
                    </div>

                    <!-- Radio -->
                    <div class="row">
                        <div class="notas">
                            <template v-for="item in notas">
                                <div class="bloco" :key="item">
                                    <div :class="'escolha '+(nrScore == item? 'ativo':'')" attr-value="0" @click="nrScore = item">
                                        <label class="" for="star0" title="Rocks!">{{item}}</label>
                                        <!--<input type="radio" :id="'star'+item" name="rating" :value="item" class="score" @click="nrScore = item" />-->
                                    </div>
                                    <template v-if="item == 0">
                                        <label class="satus text-center">Baixa</label>
                                    </template>
                                    <template v-if="item == 5">
                                        <label class="satus text-center">Média</label>
                                    </template>
                                    <template v-if="item == 10">
                                        <label class="satus text-center">Alta</label>
                                    </template>                                    
                                </div>
                            </template>

                           
                        </div>

                    </div>

                    <!-- Radio -->

                    <p class="text-motivo mt-3">
                        Poderia tirar um tempo para nos contar o motívo de sua nota? (O que poderiamos melhorar para fazer de sua experiência melhor?)
                    </p>



                    <!--Basic textarea-->
                    <div class="md-form">
                        <textarea class="md-textarea form-control" cols="20" id="form79textarea" name="dsMotivo" rows="3" maxlength="500" v-model="dsMotivo"></textarea>
                    </div>
                </div>
                <div class="modal-footer pb-0 justify-content-center">
                    <button class="btn btn-blue waves-effect waves-light" type="button" @click="enviar">
                        Enviar
                        <i class="fa fa-paper-plane ml-1"></i>
                    </button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoSucesso } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalNps',
        data: function () {
            return {
                responde: false,
                showModal: false,
                hideModal: false,

                nrScore: null,
                dsMotivo: null,
                notas: [0,1,2,3,4,5,6,7,8,9,10],
            }
        },
        computed: {
            liberaSalvar() {
                if (this.nrScore == '' || this.nrScore == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            close() {
                this.$refs['modal-trasmissao'].hide();
            },

            load() {
                this.carregaNps();
            },

            carregaNps() {
                let $this = this;
                axios.get(`${urlApi}/Nps/VerificaNps`)
                    .then(res => {
                        if (res.data.success) {
                            $this.responde = res.data.data;

                            if ($this.responde) {
                                $this.showModal = true;
                            }
                        } else {
                            $this.responde = false;
                        }
                    })
                    .catch(function () {
                        $this.responde = false;
                    });
            },

            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Nps`, { nrScore: $this.nrScore, dsMotivo: $this.dsMotivo })
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Avaliação enviada com sucesso!");
                                $this.hideModal = true;
                            } else {
                                avisoErro("Não foi possível registrar a avaliação.");
                            }
                        })
                        .catch(function(){
                            avisoErro("Não foi possível registrar a avaliação.");
                        });
                }
                return false;
            },

            checkForm() {
                if (this.nrScore === '' || this.nrScore === null) {
                    avisoErro("Necessário selecionar uma nota!")
                    return false;
                }


                return true;
            },

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-nps'].show();
            },

            hideModal: function () {
                this.$refs['modal-nps'].hide();
            }
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* ModalNps */
    .modal-titulo {
        padding-bottom: 20px;
        border-bottom: 2px solid #034471;
        justify-content: space-between;
    }
    .heading {
        color: #FFF;
        font-size: 1em;
        font-weight: 400;
    }

    .notas {
        padding: 0 15px;
        display: flex;
        flex-wrap: wrap;
    }

        .notas .bloco .satus {
            font-size: 14px;
            color: #898989;
        }

        .notas .bloco .escolha {
            background: #D4D4D4;
            border-radius: 5px;
            padding: 10px 15px;
            cursor: pointer;
            margin-right: 5px;
        }


            .notas .bloco .escolha label {
                font-size: 1.5em;
                color: #898989;
                font-weight: bold;
                cursor: pointer;
            }

            .notas .bloco .escolha:hover {
                background: #03568C;
            }

                .notas .bloco .escolha:hover label {
                    color: #FFF;
                }

            .notas .bloco .escolha.ativo {
                background: #03568C;
            }

                .notas .bloco .escolha.ativo label {
                    color: #FFF;
                }


            .notas .bloco .escolha .score {
                display: none;
            }

    .text-motivo {
        color: #898989;
    }

</style>

